// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.align-content {
  width: 100vw;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.banner {
  max-width: 40vw;
  max-height: 40vh;
}

.loader-splash {
  width: 45px;
  height: 45px;
  display: inline-flex;
  padding: 0px;
  border-radius: 100%;
  border: 5px solid;
  border-top-color: #2F73A2;
  border-bottom-color: rgba(255, 255, 255, 0.3);
  border-left-color: #639EBC;
  border-right-color: rgba(255, 255, 255, 0.3);
  animation: loader-splash 1s ease-in-out infinite;
}

.align-loader-custom {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
}

@keyframes loader-splash {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/splash/splash.page.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,eAAA;EACA,gBAAA;AACJ;;AAGA;EACI,WAAA;EACA,YAAA;EACA,oBAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,yBAAA;EACA,6CAAA;EACA,0BAAA;EACA,4CAAA;EAEA,gDAAA;AAAJ;;AAGA;EACI,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;AAAJ;;AAGA;EACI;IACI,uBAAA;EAAN;EAGE;IACI,yBAAA;EADN;AACF","sourcesContent":[".align-content {\n    width: 100vw;\n    min-height: 100vh;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.banner {\n    max-width: 40vw;\n    max-height: 40vh;\n}\n\n// loader\n.loader-splash {\n    width: 45px;\n    height: 45px;\n    display: inline-flex;\n    padding: 0px;\n    border-radius: 100%;\n    border: 5px solid;\n    border-top-color: #2F73A2;\n    border-bottom-color: rgba(255, 255, 255, 0.3);\n    border-left-color: #639EBC;\n    border-right-color: rgba(255, 255, 255, 0.3);\n    -webkit-animation: loader-splash 1s ease-in-out infinite;\n    animation: loader-splash 1s ease-in-out infinite;\n}\n\n.align-loader-custom {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin: 0 auto;\n}\n\n@keyframes loader-splash {\n    from {\n        transform: rotate(0deg);\n    }\n\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n@-webkit-keyframes loader-splash {\n    from {\n        -webkit-transform: rotate(0deg);\n    }\n\n    to {\n        -webkit-transform: rotate(360deg);\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
